<template>
  <div class="main">
    <dd-header></dd-header>
    <div class="title">
      <div>カート</div>
    </div>
    <article>
      <section class="product">
        <div>画像</div>
        <div class="product_content">
          <div>
            <div>注文ID</div>
            <div>SO10000000000</div>
          </div>
          <div>
            <div>注文期限</div>
            <div>2023/10/23</div>
          </div>
          <div>¥100,000</div>
        </div>
      </section>
      <section class="total_price">
        <div>合計金額:</div>
        <div>¥100,000</div>
      </section>
      <section>
        <div class="form_submit" @click="onOrder">
          <button type="button">注文する</button>
        </div>
      </section>
    </article>
    <dd-footer></dd-footer>
  </div>
</template>
<script>
// import * as App from '../utils/App'
import {mapActions, mapState} from 'vuex'
import {PAYMENT_STATUS} from '../constants/Type'
import Header from '../components/Header'
import Footer from '../components/Footer'

export default {
  components: {
    'dd-header': Header,
    'dd-footer': Footer
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      cartData: state => state.cartData
    }),
    nowList: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return {}
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
    },
    afterList: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return {}
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.AFTER_CART.code)
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    onOrder: function () {
      console.log('on order')
      this.$router.push({
        name: 'OrderInput'
      })
    }
  },
  mounted () {
    this.$store.dispatch('loadCartData', {reload: true})
  },
  created () {
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/order.scss" lang="scss" scoped></style>
<style src="../css/upload.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/Cart.vue